import { Document } from '@/shared/api/transcriptor/transcriptorApi';

export const getDocumentTabValue = (document: Document): string =>
  document.code ?? document.id ?? '';

export const getDocumentLabel = (document: Document): string =>
  document.tab_title ?? document.name ?? document.code ?? '—';
